import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <g transform="matrix(1.689640998840332, 0, 0, 1.5092957019805908, -0.14570599794387995, -2.251791000366211)">
    <path
      d="M 0.113 10.561 C 0.139 10.121 0.226 9.693999999999999 0.373 9.281 C 0.533 8.868 0.753 8.501 1.033 8.181 C 1.326 7.861 1.6789999999999998 7.601 2.093 7.401 C 2.5060000000000002 7.201 2.992 7.101 3.553 7.101 C 4.099 7.101 4.566 7.194 4.953 7.381 C 5.353 7.554 5.713 7.754 6.033 7.981 C 6.353 8.194 6.646 8.394 6.913 8.581 C 7.193 8.754 7.486 8.841 7.792 8.841 C 8.233 8.841 8.579 8.693999999999999 8.833 8.401 C 9.086 8.108 9.273 7.634 9.393 6.981 L 10.973 6.981 C 10.946 7.408 10.859 7.828 10.713 8.241 C 10.566 8.654 10.353 9.028 10.073 9.361 C 9.793 9.681 9.446 9.941 9.033 10.141 C 8.633 10.341 8.153 10.441 7.593 10.441 C 7.059 10.441 6.593 10.354 6.193 10.181 C 5.792 9.994 5.426 9.794 5.093 9.581 C 4.759 9.354 4.453 9.154 4.173 8.981 C 3.893 8.794 3.606 8.701 3.313 8.701 C 2.886 8.701 2.539 8.848 2.273 9.141 C 2.006 9.434 1.819 9.908 1.713 10.561 L 0.113 10.561 Z"
      fill="#21201F"
    />
  </g>,
  'Tilde',
)
